// extracted by mini-css-extract-plugin
export default {"wrapper":"jackpot_wrapper__QeJ1l","section-spacing":"jackpot_section-spacing__r5OX-"};